export default __webpack_public_path__ + "static/media/port-logo-move.e743557e.webp";